module.exports = __webpack_public_path__ + "static/img/user-avatar.77d52556.png";